/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import React, { ReactElement } from "react";
import { InfoBarTypes } from "reducer/appReducer";
import InfoSpan from "components/InfoSpan";

interface ValueLabelProps {
  infoType?: InfoBarTypes;
  label: string | null;
  children: ReactElement | null | string;
}

const ValueWithLabel: React.FC<ValueLabelProps> = (props: ValueLabelProps) => {
  const { infoType, label, children } = props;
  return (
    <div className="gsui-value-label">
      <div className="gsui-value-label_label">
        {label}
        {infoType && <InfoSpan spanType={infoType} />}
      </div>
      <div className="gsui-value-label_value">{children}</div>
    </div>
  );
};

export default ValueWithLabel;
